module.exports = __webpack_public_path__ + "img/parner_program.bb529e34.png";